cv.TeamProjectsRowView = Marionette.LayoutView.extend({
  className: 'member',
  template : cv.Templates['team/projects_row'],

  bindings : {
    '.tag' : {
      observe : 'team.role',
      update: function($el, value, model, options) {
        $el.text(model.get('team.role'));
      }
    },
    '.member-dropdown' : {
      observe : 'team.role',
      update: function($el, value, model, options){
        if(model.get('team.role') == 'admin'){
          $el.find('.toggle-admin').html('Remove Admin');
        }else{
          $el.find('.toggle-admin').html('Make Admin');
        }
      }
    },
  },

  events : {
    'click .manage-member' : 'manageMember',
    'click .toggle-admin' : 'toggleAdmin',
    'click .remove-member' : 'removeFromTeam'
  },

  initialize: function(options){
    this.options = _.extend(this.options, options);

    this.listenTo(vent, 'team_members:manage_member', function(project_id){
      this.$el.removeClass('active');
      if(this.model.get('id') == project_id){
        this.$el.addClass('active');
      }
    }, this);

    console.log('TeamProjectsRowView initialized');
  },

  templateHelpers: function(){
    if(this.model.get('stub') == ''){
      var status = 'incomplete';
    }else{
      if(this.model.get('active') == 1){
        var status = 'enabled';
      }else{
        var status = 'disabled';
      }
    }

    return {
      status : status,
      id : this.model.get('id'),
      incomplete : this.model.get('stub') == '' ? true : false,
      fundraiser : this.model.get('user.first_name') != '' ? this.model.get('display_name') : '<span class="incomplete">(Incomplete)</span>',
      email : this.model.get('user.email'),
      stub : this.model.get('stub'),
      url : this.model.get('url'),
      currency_sign : cv.currencySign(cv.campaign.get('currency_code')),
      funds_needed : cv.formatMoney({
        show_sign : true,
        amount : this.model.get('funds_needed'),
        currency_code : cv.campaign.get('currency_code'),
        decimal_places : 2
      }),
      funds_raised : cv.formatMoney({
        show_sign : true,
        amount : this.model.get('funds_raised'),
        currency_code : cv.campaign.get('currency_code'),
        decimal_places : 2
      }),
      role : this.model.get('team.role'),
      num_donations : cv.numberWithCommas(this.model.get('num_donations')),
      created_at_date : moment(this.model.get('created_at') + 'Z').tz(cv.campaign.get('timezone')).format('MMM D'),
      created_at_time :  moment(this.model.get('created_at') + 'Z').tz(cv.campaign.get('timezone')).format('h:mm A'),

      is_self : this.model.get('id') == cv.project.get('id') ? true : false,
      is_admin : this.model.get('team.role') == 'admin' ? true : false,
      is_member : this.model.get('team.role') == 'member' ? true : false,

      can_manage : this.options.team_model.get('id') == cv.project.get('team.id') && cv.project.get('team.role') == 'admin' ? true : false
    }
  },

  manageMember: function(e){
    e.preventDefault();

    if(!this.$el.hasClass('active')){
      vent.trigger('team_members:manage_member', this.model.get('id'));
    }
  },

  toggleAdmin: function(e){
    e.preventDefault();

    if(this.model.get('team.role') == 'member'){
      var view = new cv.ConfirmView({
        message : 'Are you sure you want to make this team member an admin?  They will be able to edit the team information and members.'
      });
      vent.trigger('modal:show', view);

      view.on('confirm', function(){
        $.ajax({
          url: cv.api_path + '/teams/' + this.model.get('team.id') + '/promote_member/' + this.model.get('id'),
          dataType: "json",
          type: 'post',
          success: _.bind(function(data){
            this.model.set('team.role', 'admin');

            vent.trigger('notif:success', 'Team member has been promoted to admin.');
          }, this)
        });
      }, this);
    }else{
      var view = new cv.ConfirmView({
        message : 'Are you sure you want to remove this member from admin?'
      });
      vent.trigger('modal:show', view);

      view.on('confirm', function(){
        $.ajax({
          url: cv.api_path + '/teams/' + this.model.get('team.id') + '/demote_member/' + this.model.get('id'),
          dataType: "json",
          type: 'post',
          success: _.bind(function(data){
            this.model.set('team.role', 'member');

            vent.trigger('notif:success', 'Team member has been removed from admin.');
          }, this)
        });
      }, this);
    }
  },

  removeFromTeam: function(e){
    e.preventDefault();

    var view = new cv.ConfirmView({
      message : 'Are you sure you want remove this member from the team?'
    });
    vent.trigger('modal:show', view);

    view.on('confirm', function(){
      $.ajax({
        url: cv.api_path + '/teams/' + this.model.get('team.id') + '/remove_member/' + this.model.get('id'),
        dataType: "json",
        type: 'post',
        success: _.bind(function(data){
          this.$el.fadeOut("slow", _.bind(function(){
            // Refresh the team to update values
            vent.trigger('team:refresh');

            this.model.collection.remove(this.model);
          }, this));

          vent.trigger('notif:success', 'Team member has been removed from this team.');
        }, this)
      });
    }, this);
  },

  onAttach: function(){
    this.$('.profile-photo').attr('data-src', cv.photo({
      photo_path : this.model.get('user.photo_path'),
      photo_default : cv.campaign.get('default_fundraiser_photo'),
      url_only : true,
      transforms : {
        fit : 'crop'
      }
    }));

    // Bind stickit
    this.stickit();
  }
});
